module.exports = __webpack_public_path__ + "imgs/cover.png";


//////////////////
// WEBPACK FOOTER
// ./apps/assets/img/cover.png
// module id = 538
// module chunks = 0